export const RACETIME_REGEX = /^(\d{2}):(\d{2})\.(\d{2})$/;

export const raceTimeToSeconds = (value) => {
  if (typeof value !== "string") return null;
  const cleaned = value.trim();
  const match = cleaned.match(RACETIME_REGEX);
  if (!match) return null;

  const minutes = Number(match[1]);
  const seconds = Number(match[2]);
  const centiseconds = Number(match[3]);
  if (!Number.isFinite(minutes) || !Number.isFinite(seconds) || !Number.isFinite(centiseconds)) {
    return null;
  }
  if (seconds > 59) return null;

  return minutes * 60 + seconds + centiseconds / 100;
};

export const isValidRaceTime = (value) => {
  if (typeof value !== "string") return false;
  const cleaned = value.trim();
  if (!RACETIME_REGEX.test(cleaned)) return false;
  return raceTimeToSeconds(cleaned) !== null;
};
